document.addEventListener('DOMContentLoaded', function() {

  const opening = document.getElementById('jl-opening');
  if (!opening) return;

  const sprite = opening.querySelector('.jl-opening__sprite');
  if (!sprite) return;

  // ====== 1回だけ表示（同じタブ内） ======
  // リロードでも2回目以降は出さない → sessionStorage
  const KEY = 'junction_opening_seen_once';
  if (sessionStorage.getItem(KEY) === '1') {
    opening.remove(); // 2回目以降は即消す（黒い被せを残さない）
    return;
  }
  sessionStorage.setItem(KEY, '1');
  // =======================================

  // ====== アニメ設定 ======
  const FRAMES = 12;
  const FRAME_W = 160;
  const FPS = 6;
  const interval = 1000 / FPS;
  const LOOPS = 2;
  const FADE_MS = 700;
  const WAIT_MS = 600;
  // =======================

  let i = 1;
  let loops = 0;

  const tick = () => {
    // 念のため：CSSの固定が残ってても効くように setProperty
    sprite.style.setProperty(
      'background-position',
      `${-(FRAME_W * i)}px 0px`,
      'important'
    );

    i++;
    if (i >= FRAMES) {
      i = 0;
      loops++;
      if (loops >= LOOPS) finish();
    }
  };

  const finish = () => {
  clearInterval(timer);

  // 最後のコマで余韻
  setTimeout(() => {
    opening.classList.add('is-hide');
    setTimeout(() => opening.remove(), FADE_MS);
  }, WAIT_MS);
};

  tick();
  const timer = setInterval(tick, interval);

});